import React, { useState } from "react";
import ModulesImage from "../../../asset/images/home/modules.png"; // Update the path if needed
import { Link } from 'react-router-dom';

const DashboardModules = () => {
    const [activeModule, setActiveModule] = useState(1);

    return (
        <>
            <style>
                {`
        .modules-container {
            height: calc(100vh - 200px);
            overflow-y: auto;
            margin-right: -10px; /* Negative margin to pull scrollbar to the edge */
            padding-right: 10px; /* Internal padding for content */
        }

        /* Webkit scrollbar styling */
        .modules-container::-webkit-scrollbar {
            width: 6px;
        }

        .modules-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
        }

        .modules-container::-webkit-scrollbar-thumb {
            background: #1A588B;
            border-radius: 10px;
        }

        .modules-container::-webkit-scrollbar-thumb:hover {
            background: #059669;
        }

        /* Firefox scrollbar styling */
        .modules-container {
            scrollbar-width: thin;
            scrollbar-color: #1A588B #f1f1f1;
        }

        /* Module details styling - matching screenshots exactly */
        .module-details {
            display: none;
        }

        .module-details.active {
            display: block;
        }

        .detail-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            font-size: 14px;
            color: #6b7280;
        }

        .detail-title {
            font-size: 18px;
            color: #2d2f32;
        }

        .detail-date {
            font-size: 12px;
            color: #090a0b;
            background-color: #E2F2FF;
            padding: 10px;
            border-radius: 20px;
        }
        .lesson-style {
            font-size: 12px;
            color: #090a0b;
            background-color: #E2F2FF;
            padding: 10px 20px; /* top/bottom: 10px, left/right: 20px */
            border-radius: 20px;
            margin-left: 5px;
        }

        .lesson-section {
            margin-bottom: 24px;
        }

        .lesson-title {
            font-size: 45px;
            font-weight: 600;
            margin-bottom: 16px;
            line-height: 40px;
        }

        .lesson-image {
            width: 100%;
            background-color: #e5e7eb;
            border-radius: 8px;
            margin-bottom: 16px;
            overflow: hidden;
        }

        .lesson-info {
            display: flex;
            margin-bottom: 24px;
            font-size: 14px;
            color: #6b7280;
        }

        .start-lesson-btn {
            background: linear-gradient(to right, #439D55, #059669);
            color: white;
            border: none;
            border-radius: 50px;
            padding: 20px 24px;
            font-size: 26px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            width: 100%;
        }

        .start-lesson-btn:hover {
            background: linear-gradient(to right, #059669, #439D55);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
        }

        /* Settings button styling */
        .settings-button {
            width: 100%;
            border-radius: 12px;
            overflow: hidden;
            transition: all 0.3s ease;
            margin-bottom: 16px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: space-between;
            padding: 10px 20px;
        }

        .button-content {
            display: flex;
            flex-grow: 1;
        }

        .button-icon {
            width: 24px;
            height: 24px;
            margin-right: 16px;
        }

        .button-arrow {
            width: 20px;
            height: 20px;
        }

        /* Default state for buttons */
        .settings-button:not(.active) {
            background-color: white;
            border: 2px solid #1A588B;
        }

        .settings-button:not(.active) .button-icon {
            color: #1A588B;
        }

        .settings-button:not(.active) .button-content span,
        .settings-button:not(.active) .button-arrow {
            color: #1A588B;
        }

        /* Hover state for non-active buttons - looks like active button */
        .settings-button:not(.active):hover {
            background: linear-gradient(to right, #1A588B, #059669);
            color: white;
            border: none;
            border-radius: 16px;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .settings-button:not(.active):hover .button-icon,
        .settings-button:not(.active):hover .button-content span,
        .settings-button:not(.active):hover .button-arrow {
            color: white;
        }

        /* Active state for certificate button */
        .settings-button.active {
            background: linear-gradient(to right, #1A588B, #059669);
            color: white;
            border: none;
            border-radius: 16px;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        /* Hover state for active button - stays the same */
        .settings-button.active:hover {
            background: linear-gradient(to right, #1A588B, #059669);
            color: white;
            border: none;
            border-radius: 16px;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .settings-button.active .button-icon,
        .settings-button.active .button-content span,
        .settings-button.active .button-arrow {
            color: white;
        }

        .settings-button.active:hover .button-icon,
        .settings-button.active:hover .button-content span,
        .settings-button.active:hover .button-arrow {
            color: white;
        }

        /* Module progress info */
        .module-progress {
            font-size: 10px;
            margin-top: 4px;
        }

        /* Increase left sidebar width */
        @media (min-width: 1024px) {
            .grid-cols-1.lg\\\\:grid-cols-3 {
                grid-template-columns: 2fr 3fr;
            }
        }

        .modules-text{
            text-align: left !important;
        }
        .modules-text-style{
            font-size: 10px;
        }
        .modules-bold{
            font-weight: bold;
        }
 `}
            </style>

        <div className="bg-[#E2F2FF] rounded-xl p-3 lg:p-3 shadow-md border border-blue-200">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Left Column - Course Modules */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <h3 className="text-2xl font-bold mb-4 text-gray-600">
                                Course Modules
                            </h3>

                            {/* Modules Container with Scrollbar */}
                            <div className="modules-container">
                                {[1, 2, 3, 4, 5].map((module) => {
                                    const titles = [
                                        "What is the Science of Reading?",
                                        "Understanding Grammar",
                                        "Reading Comprehension",
                                        "Vocabulary Development",
                                        "Fluency Practice",
                                    ];
                                    const counts = ["0/10", "0/8", "0/12", "0/10", "0/8"];
                                    const times = ["3 Hours", "2.5 Hours", "4 Hours", "3.5 Hours", "2 Hours"];
                                    const icons = [
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                                        />,
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                        />,
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                        />,
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                                        />,
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M13 10V3L4 14h7v7l9-11h-7z"
                                        />,
                                    ];
                                    return (
                                        <button
                                            key={module}
                                            className={`settings-button ${activeModule === module ? "active" : ""}`}
                                            onClick={() => setActiveModule(module)}
                                        >
                                            <div className="button-content">
                                                <svg
                                                    className="button-icon"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    {icons[module - 1]}
                                                </svg>
                                                <div className="modules-text">
                                                    <span className="modules-text-style">Module {module}</span>
                                                    <br />
                                                    <span className="modules-bold">{titles[module - 1]}</span>
                                                    <div className="module-progress">
                                                        {counts[module - 1]} Completed | Estimated Time: {times[module - 1]}
                                                    </div>
                                                </div>
                                            </div>
                                            <svg
                                                className="button-arrow"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M9 5l7 7-7 7"
                                                />
                                            </svg>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Module Details */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-xl shadow-md p-6">
                            {[1, 2, 3, 4, 5].map((module) => {
                                const lessonTitles = [
                                    "What is the Science of Reading?",
                                    "Understanding Grammar?",
                                    "Building Vocabulary?",
                                    "Comprehension Strategies?",
                                    "Analyzing Texts?",
                                ];
                                return (
                                    <div
                                        key={module}
                                        id={`module-${module}`}
                                        className={`module-details ${activeModule === module ? "active" : ""}`}
                                    >
                                        <div className="detail-header">
                                            <div className="detail-title">Module Details</div>
                                            <div className="detail-date">Updated on Jan 01, 2025</div>
                                        </div>

                                        <div className="lesson-section">
                                            <div className="lesson-title">Lesson 1: {lessonTitles[module - 1]}</div>
                                            <div className="lesson-image">
                                                <img
                                                    src={ModulesImage}
                                                    alt={lessonTitles[module - 1]}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            <div className="lesson-info">
                                                <div className="lesson-style">Completed: 0/10</div>
                                                <div className="lesson-style">Duration: 2 hours</div>
                                            </div>
                                        </div>

                                        <Link to={'/dashboard/modules/lesson-read'}>
                                            <button className="start-lesson-btn">Start Lesson</button>
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default DashboardModules;
